import { render, staticRenderFns } from "./CertificationsPanel.vue?vue&type=template&id=25243c14&"
import script from "./CertificationsPanel.vue?vue&type=script&lang=js&"
export * from "./CertificationsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports